import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { sevkiyatService } from '../api/dbService';
import PageLayout from '../components/PageLayout';
import LoadingSpinner from '../components/LoadingSpinner';

export default function ShipmentHistory() {
  const [sevkiyatlar, setSevkiyatlar] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [baslangic, setBaslangic] = useState('');
  const [bitis, setBitis] = useState('');

  useEffect(() => {
    sevkiyatService.getGecmisSevkiyatlar()
      .then(res => setSevkiyatlar(res.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filtered = sevkiyatlar.filter(s => {
    const matchSearch = !search || [s.sevkiyat_no, s.sevkiyat_adi, s.plaka, s.urun, s.device_id]
      .some(v => v?.toLowerCase().includes(search.toLowerCase()));
    const tarih = s.tamamlanma_tarihi ? new Date(s.tamamlanma_tarihi) : null;
    const matchBaslangic = !baslangic || (tarih && tarih >= new Date(baslangic));
    const matchBitis = !bitis || (tarih && tarih <= new Date(bitis + 'T23:59:59'));
    return matchSearch && matchBaslangic && matchBitis;
  });

  return (
    <PageLayout>
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <h5 className="mb-0 fw-semibold">Geçmiş Sevkiyatlar</h5>
        <div className="d-flex gap-2 flex-wrap align-items-center">
          <input
            type="date" className="form-control form-control-sm"
            value={baslangic} onChange={e => setBaslangic(e.target.value)}
            style={{ maxWidth: 150 }} title="Başlangıç tarihi"
          />
          <span className="text-muted small">—</span>
          <input
            type="date" className="form-control form-control-sm"
            value={bitis} onChange={e => setBitis(e.target.value)}
            style={{ maxWidth: 150 }} title="Bitiş tarihi"
          />
          <input
            className="form-control form-control-sm"
            placeholder="Ara..."
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ minWidth: 180 }}
          />
        </div>
      </div>

      {loading ? <LoadingSpinner /> : (
        <div className="card">
          <div className="table-responsive">
            <table className="table table-hover table-sm align-middle mb-0">
              <thead className="table-light">
                <tr>
                  <th>No</th><th>Adı</th><th>Cihaz</th><th>Güzergah</th>
                  <th>Ürün</th><th>Tamamlanma</th><th></th>
                </tr>
              </thead>
              <tbody>
                {filtered.length === 0 ? (
                  <tr><td colSpan={7} className="text-center text-muted py-5">
                    <i className="fas fa-flag-checkered fa-2x d-block mb-2 opacity-25"></i>
                    Kayıt bulunamadı
                  </td></tr>
                ) : filtered.map(s => (
                  <tr key={s.id}>
                    <td><small className="text-muted">{s.sevkiyat_no}</small></td>
                    <td>{s.sevkiyat_adi}</td>
                    <td><code>{s.device_id}</code></td>
                    <td><small>{s.cikis_noktasi} → {s.varis_noktasi}</small></td>
                    <td>{s.urun || '—'}</td>
                    <td>
                      <small className="text-muted">
                        {s.tamamlanma_tarihi
                          ? new Date(s.tamamlanma_tarihi).toLocaleDateString('tr-TR')
                          : '—'}
                      </small>
                    </td>
                    <td>
                      <Link to={`/view/${s.id}`} className="btn btn-outline-secondary btn-sm py-0">Detay</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="card-footer py-2 text-muted small">
            {filtered.length} / {sevkiyatlar.length} kayıt gösteriliyor
          </div>
        </div>
      )}
    </PageLayout>
  );
}
